import { Injectable, Injector, inject } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import {Observable} from 'rxjs';
import {SessionService} from '@shared/services/session.service';

@Injectable({
  providedIn: 'root'
})
export class AdministrationInterceptor implements HttpInterceptor {
  private readonly inj = inject(Injector);


  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {


    const url = this.getConfig().api.backend;
    if (req.url.startsWith(url) && !req.url.endsWith('/authenticate/administrations')) {
      const sessionService = this.inj.get(SessionService);

      let administrationUuid = '';
      if (sessionService?.session?.administration) {
        administrationUuid = '' + sessionService.session.administration.uuid;
      }

      req = req.clone({
        setHeaders: {
          'X-Administration': administrationUuid
        }
      });
    }


    return next.handle(req);
  }

  private getConfig() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (window as any).APP_CONFIG;
  }
}
